var map = {
	"./openAccType3-1.png": 1346,
	"./openAccType3-2.png": 1347
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1345;


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/oldCode ^\.\/openAccType3\-.*\.png$
// module id = 1345
// module chunks = 2